// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"470":"de7260c6","496":"0d96eef2","787":"aea19ca2","968":"98c50d42"}[chunkId] + ".chunk.js";
};